export default __webpack_public_path__ + "static/media/banner_networking.1bc31dbf.png";